import { render, staticRenderFns } from "./Our_culture.vue?vue&type=template&id=7fcafe76&scoped=true"
import script from "./Our_culture.vue?vue&type=script&lang=js"
export * from "./Our_culture.vue?vue&type=script&lang=js"
import style0 from "./Our_culture.vue?vue&type=style&index=0&id=7fcafe76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcafe76",
  null
  
)

export default component.exports